import React, { memo } from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import {
  AddShoppingCart as AddShoppingCartIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { DIAMOND_TYPES } from '../../constants/appConstants';
import { useCartActions, useCartData } from '../../context/CartContext';
import { useFeedback } from '../../context/FeedbackContext';

/**
 * Cart action for a certified row. Subscribes to cart context locally so the
 * inventory page does not re-render the full table on every add-to-cart.
 */
function CertifiedDiamondCartAction({ diamond, canAddToCart, layout = 'inline' }) {
  const { t } = useTranslation();
  const { addToCart } = useCartActions();
  const { isInCart } = useCartData();
  const { showSuccess } = useFeedback();

  if (!canAddToCart || diamond.status !== 'available') {
    return layout === 'inline' ? null : <Box />;
  }

  const inCart = isInCart(diamond._id);

  const handleClick = () => {
    addToCart({ type: DIAMOND_TYPES.CERTIFIED, diamond });
    showSuccess(`${diamond.certificateNumber} added to cart`);
  };

  if (inCart) {
    return (
      <Tooltip title={t('inventory.inCart')}>
        <span>
          <IconButton size="small" color="success" disabled>
            <CheckCircleIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={t('inventory.addToCart')}>
      <IconButton
        size="small"
        color="primary"
        onClick={handleClick}
        sx={{ border: '1px solid', borderColor: 'primary.main' }}
      >
        <AddShoppingCartIcon fontSize="small" />
      </IconButton>
    </Tooltip>
  );
}

export default memo(CertifiedDiamondCartAction);
